import React, { useCallback, useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { useUpdateComponentState } from '../../../hooks';
import FlipCardGrid from '../../components/FlipCardGrid';
import NumberedStepsCarousel from '../../components/NumberedStepsCarousel';
import { getCivilIcon } from '../../components/CivilIcons';
import Grid1 from '../../../../../../assets/civil/frameworks/grid1.png';
import Grid2 from '../../../../../../assets/civil/frameworks/grid2.png';
import Grid3 from '../../../../../../assets/civil/frameworks/grid3.png';
import Grid4 from '../../../../../../assets/civil/frameworks/grid4.png';

const GRID_ILLUSTRATIONS = [Grid1, Grid2, Grid3, Grid4];

interface ISection3Props {
  settings: any;
}

const Section3: React.FunctionComponent<ISection3Props> = ({ settings }) => {
  const ID = '4';
  const param = useParams();
  const p_course = param.course || '';
  const p_topic = param['*'] || 'welcome';
  const updateComponentState = useUpdateComponentState();
  const paragraphSettings = useMemo(
    () => settings?.paragraphs?.[3],
    [settings?.paragraphs]
  );

  const handleComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-frameworks-section3-1');
  }, [updateComponentState, p_course, p_topic]);

  const handleStepsComplete = useCallback(() => {
    updateComponentState(p_course, p_topic, ID, 'civil-frameworks-section3-2');
  }, [updateComponentState, p_course, p_topic]);

  return (
    <div className="frameworks-section">
      <div className="content-block content-block-cards">
        <FlipCardGrid
          id="civil-frameworks-section3-1"
          mainTitle={paragraphSettings?.title}
          subTitle={paragraphSettings?.section2Title}
          description={paragraphSettings?.section2Desc}
          items={(paragraphSettings?.section2Items || []).map(
            (item: any, index: number) => ({
              title: item.title || '',
              content: item.content || '',
              icon: getCivilIcon(item.icon),
              illustration: (
                <img
                  src={GRID_ILLUSTRATIONS[index % GRID_ILLUSTRATIONS.length]}
                  alt=""
                />
              ),
            })
          )}
          onComplete={handleComplete}
        />
      </div>
      <div className="content-block content-block-steps">
        <NumberedStepsCarousel
          type="simple"
          id="civil-frameworks-section3-2"
          mainTitle={paragraphSettings?.section3Title}
          description={paragraphSettings?.section3Desc}
          items={(paragraphSettings?.section3Items || []).map((item: any) => ({
            text: item.text || '',
          }))}
          defaultActive={0}
          onComplete={handleStepsComplete}
        />
      </div>
    </div>
  );
};

export default Section3;
